import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70f54d1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "charging-range-split" }, "-", -1))
const _hoisted_3 = {
  key: 0,
  style: {"height":"32px","display":"block","width":"100%"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#409eff"} }, "（公式计算得出）", -1))
const _hoisted_5 = { key: 6 }
const _hoisted_6 = { key: 7 }
const _hoisted_7 = {
  key: 0,
  class: "description-fields"
}
const _hoisted_8 = { class: "sailing-date-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_price_table_column_crud = _resolveComponent("price-table-column-crud")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.form.Rules)
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          model: _ctx.form,
          ref: "ruleForm",
          "label-width": "150px",
          inline: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "left" }, {
              default: _withCtx(() => [
                _createTextVNode("计算要素")
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.FieldValues, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.ColumnId
              }, [
                (item.ColumnFieldType == 1 || item.ColumnFieldType == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      (item.ColumnFieldCode == 'CostId')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            prop: `Data.FieldValues[${i}].CostId`,
                            rules: _ctx.form.Rules.CostId,
                            label: item.Name
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_select, {
                                modelValue: item.CostId,
                                "onUpdate:modelValue": ($event: any) => ((item.CostId) = $event),
                                label: item.Label,
                                "onUpdate:label": ($event: any) => ((item.Label) = $event),
                                options: item.Options,
                                remote: true,
                                remoteMethod: item.Query,
                                "no-data-text": '无匹配的信息，请至参数管理-费用名称中添加'
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options", "remoteMethod"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "rules", "label"]))
                        : (item.ColumnFieldCode == 'VolumeRatio')
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 1,
                              prop: `Data.FieldValues[${i}].VolumeRatio`,
                              rules: _ctx.form.Rules.VolumeRatio,
                              label: item.Name
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  modelValue: item.VolumeRatio,
                                  "onUpdate:modelValue": ($event: any) => ((item.VolumeRatio) = $event),
                                  number: true,
                                  pattern: "[0-9.]"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules", "label"]))
                          : (item.ColumnFieldCode == 'MinChargingStandardUnitId')
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 2,
                                label: item.Name,
                                class: "min-charging-standard"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: `Data.FieldValues[${i}].MinChargingStandard`,
                                    rules: _ctx.form.Rules.MinChargingStandard,
                                    class: "min-charging-standard-value"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_input, {
                                        modelValue: item.MinChargingStandard,
                                        "onUpdate:modelValue": ($event: any) => ((item.MinChargingStandard) = $event),
                                        number: true,
                                        pattern: "[0-9.]"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["prop", "rules"]),
                                  _createVNode(_component_el_form_item, {
                                    prop: `Data.FieldValues[${i}].MinChargingStandardUnitId`,
                                    rules: _ctx.form.Rules.MinChargingStandardUnitId,
                                    class: "min-charging-standard-unit-id"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_select, {
                                        modelValue: item.MinChargingStandardUnitId,
                                        "onUpdate:modelValue": ($event: any) => ((item.MinChargingStandardUnitId) = $event),
                                        label: item.MinChargingStandardUnitLabel,
                                        "onUpdate:label": ($event: any) => ((item.MinChargingStandardUnitLabel) = $event),
                                        options: 
                _ctx.form.Data.FieldValues?.any(
                  (it) => it.ColumnFieldCode == 'VolumeRatio' && it.VolumeRatio
                )
                  ? _ctx.paramUnits.filter(
                      (it) => it.Label == 'KGS' || it.Label == 'CBM'
                    )
                  : _ctx.paramUnits
              
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                                    ]),
                                    _: 2
                                  }, 1032, ["prop", "rules"])
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            : (item.ColumnFieldCode == 'ChargingRange')
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 3,
                                  label: item.Name,
                                  class: "charging-range"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      prop: `Data.FieldValues[${i}].ChargingRangeMin`,
                                      rules: _ctx.form.Rules.ChargingRangeMin,
                                      class: "charging-range-min"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          modelValue: item.ChargingRangeMin,
                                          "onUpdate:modelValue": ($event: any) => ((item.ChargingRangeMin) = $event),
                                          number: true,
                                          pattern: "[0-9.]",
                                          onHandleBlur: ($event: any) => (_ctx.onChargingRangeChanged(i))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]),
                                    _hoisted_2,
                                    _createVNode(_component_el_form_item, {
                                      prop: `Data.FieldValues[${i}].ChargingRangeMax`,
                                      rules: _ctx.form.Rules.ChargingRangeMax,
                                      class: "charging-range-max"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          modelValue: item.ChargingRangeMax,
                                          "onUpdate:modelValue": ($event: any) => ((item.ChargingRangeMax) = $event),
                                          number: true,
                                          pattern: "[0-9.]",
                                          onHandleBlur: ($event: any) => (_ctx.onChargingRangeChanged(i))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"]),
                                    _createVNode(_component_el_form_item, {
                                      prop: `Data.FieldValues[${i}].ChargingRangeUnitId`,
                                      rules: _ctx.form.Rules.ChargingRangeUnitId,
                                      class: "charging-range-unit-id"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_select, {
                                          modelValue: item.ChargingRangeUnitId,
                                          "onUpdate:modelValue": ($event: any) => ((item.ChargingRangeUnitId) = $event),
                                          label: item.ChargingRangeUnitLabel,
                                          "onUpdate:label": ($event: any) => ((item.ChargingRangeUnitLabel) = $event),
                                          options: _ctx.paramUnits,
                                          disabled: 
                !(
                  (item.ChargingRangeMin && item.ChargingRangeMin > 0) ||
                  item.ChargingRangeMax
                )
              
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options", "disabled"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules"])
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              : (item.ColumnFieldCode == 'Amount')
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 4,
                                    prop: `Data.FieldValues[${i}].Amount`,
                                    rules: _ctx.form.Rules.Amount,
                                    label: item.Name,
                                    class: "amount"
                                  }, {
                                    default: _withCtx(() => [
                                      (item.AmountFormula)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                            _createTextVNode(_toDisplayString(item.AmountFormulaErrors && item.AmountFormulaErrors.length > 0
                ? "电询"
                : item.Amount) + " ", 1),
                                            _hoisted_4
                                          ]))
                                        : (_openBlock(), _createBlock(_component_miezz_input, {
                                            key: 1,
                                            modelValue: item.Amount,
                                            "onUpdate:modelValue": ($event: any) => ((item.Amount) = $event),
                                            number: true,
                                            pattern: "[0-9.-]",
                                            onHandleBlur: ($event: any) => (_ctx.onAmountChanged(item))
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"]))
                                    ]),
                                    _: 2
                                  }, 1032, ["prop", "rules", "label"]))
                                : (item.ColumnFieldCode == 'CurrencySystemId')
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 5,
                                      prop: `Data.FieldValues[${i}].CurrencySystemId`,
                                      rules: _ctx.form.Rules.CurrencySystemId,
                                      label: item.Name
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_select, {
                                          modelValue: item.CurrencySystemId,
                                          "onUpdate:modelValue": ($event: any) => ((item.CurrencySystemId) = $event),
                                          label: item.Label,
                                          "onUpdate:label": ($event: any) => ((item.Label) = $event),
                                          options: _ctx.paramCurrencySystems
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules", "label"]))
                                  : (item.ColumnFieldCode == 'FirstChargingUnitId')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createVNode(_component_el_form_item, {
                                          prop: `Data.FieldValues[${i}].FirstChargingUnitId`,
                                          rules: _ctx.form.Rules.FirstChargingUnitId,
                                          label: item.Name
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_miezz_select, {
                                              modelValue: item.FirstChargingUnitId,
                                              "onUpdate:modelValue": ($event: any) => ((item.FirstChargingUnitId) = $event),
                                              label: item.Label,
                                              "onUpdate:label": ($event: any) => ((item.Label) = $event),
                                              options: _ctx.paramUnits
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                                          ]),
                                          _: 2
                                        }, 1032, ["prop", "rules", "label"])
                                      ]))
                                    : (item.ColumnFieldCode == 'SecondChargingUnitId')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                          _createVNode(_component_el_form_item, {
                                            prop: `Data.FieldValues[${i}].SecondChargingUnitId`,
                                            rules: _ctx.form.Rules.SecondChargingUnitId,
                                            label: item.Name
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_miezz_select, {
                                                modelValue: item.SecondChargingUnitId,
                                                "onUpdate:modelValue": ($event: any) => ((item.SecondChargingUnitId) = $event),
                                                label: item.Label,
                                                "onUpdate:label": ($event: any) => ((item.Label) = $event),
                                                options: _ctx.paramUnits
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                                            ]),
                                            _: 2
                                          }, 1032, ["prop", "rules", "label"])
                                        ]))
                                      : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (
        _ctx.form.Data.FieldValues &&
        _ctx.form.Data.FieldValues?.filter((it) => it.ColumnFieldType == 3).length >
          0
      )
              ? (_openBlock(), _createBlock(_component_el_divider, {
                  key: 0,
                  "content-position": "left"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 描述要素 ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.FieldValues, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.ColumnId
              }, [
                (item.ColumnFieldType == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (item.ColumnFieldCode == 'PortId')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            prop: `Data.FieldValues[${i}].PortId`,
                            rules: _ctx.form.Rules.PortId,
                            label: item.Name
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_select, {
                                modelValue: item.PortId,
                                "onUpdate:modelValue": ($event: any) => ((item.PortId) = $event),
                                label: item.Label,
                                "onUpdate:label": ($event: any) => ((item.Label) = $event),
                                options: item.Options,
                                remote: true,
                                remoteMethod: item.Query
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options", "remoteMethod"])
                            ]),
                            _: 2
                          }, 1032, ["prop", "rules", "label"]))
                        : (item.ColumnFieldCode == 'CountryId')
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 1,
                              prop: `Data.FieldValues[${i}].CountryId`,
                              rules: _ctx.form.Rules.CountryId,
                              label: item.Name
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_select, {
                                  modelValue: item.CountryId,
                                  "onUpdate:modelValue": ($event: any) => ((item.CountryId) = $event),
                                  label: item.Label,
                                  "onUpdate:label": ($event: any) => ((item.Label) = $event),
                                  options: item.Options,
                                  remote: true,
                                  remoteMethod: item.Query
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options", "remoteMethod"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules", "label"]))
                          : (item.ColumnFieldCode == 'AreaId')
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 2,
                                prop: `Data.FieldValues[${i}].AreaId`,
                                rules: _ctx.form.Rules.AreaId,
                                label: item.Name
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_select, {
                                    modelValue: item.AreaId,
                                    "onUpdate:modelValue": ($event: any) => ((item.AreaId) = $event),
                                    label: item.Label,
                                    "onUpdate:label": ($event: any) => ((item.Label) = $event),
                                    options: item.Options,
                                    remote: true,
                                    remoteMethod: item.Query,
                                    valueKey: "Id",
                                    labelKey: "FullName"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options", "remoteMethod"])
                                ]),
                                _: 2
                              }, 1032, ["prop", "rules", "label"]))
                            : (item.ColumnFieldCode == 'CarrierId')
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 3,
                                  prop: `Data.FieldValues[${i}].CarrierId`,
                                  rules: _ctx.form.Rules.CarrierId,
                                  label: item.Name
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_miezz_select, {
                                      modelValue: item.CarrierId,
                                      "onUpdate:modelValue": ($event: any) => ((item.CarrierId) = $event),
                                      label: item.Label,
                                      "onUpdate:label": ($event: any) => ((item.Label) = $event),
                                      options: item.Options,
                                      remote: true,
                                      remoteMethod: item.Query,
                                      onHandleFocus: item.Query
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options", "remoteMethod", "onHandleFocus"])
                                  ]),
                                  _: 2
                                }, 1032, ["prop", "rules", "label"]))
                              : (item.ColumnFieldCode == 'ChannelId')
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 4,
                                    prop: `Data.FieldValues[${i}].ChannelId`,
                                    rules: _ctx.form.Rules.ChannelId,
                                    label: item.Name
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_select, {
                                        modelValue: item.ChannelId,
                                        "onUpdate:modelValue": ($event: any) => ((item.ChannelId) = $event),
                                        label: item.Label,
                                        "onUpdate:label": ($event: any) => ((item.Label) = $event),
                                        options: item.Options,
                                        remote: true,
                                        remoteMethod: item.Query,
                                        onHandleFocus: item.Query
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options", "remoteMethod", "onHandleFocus"])
                                    ]),
                                    _: 2
                                  }, 1032, ["prop", "rules", "label"]))
                                : (item.ColumnFieldCode == 'RouteCodeId')
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 5,
                                      prop: `Data.FieldValues[${i}].RouteCodeId`,
                                      rules: _ctx.form.Rules.RouteCodeId,
                                      label: item.Name
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_select, {
                                          modelValue: item.RouteCodeId,
                                          "onUpdate:modelValue": ($event: any) => ((item.RouteCodeId) = $event),
                                          label: item.Label,
                                          "onUpdate:label": ($event: any) => ((item.Label) = $event),
                                          options: item.Options,
                                          remote: true,
                                          remoteMethod: item.Query,
                                          onHandleFocus: item.Query
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options", "remoteMethod", "onHandleFocus"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop", "rules", "label"]))
                                  : (item.ColumnFieldCode == 'Voyage')
                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 6,
                                        label: item.Name,
                                        required: true,
                                        class: "voyage"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_form_item, {
                                            prop: `Data.FieldValues[${i}].Voyage`,
                                            rules: _ctx.form.Rules.Voyage,
                                            class: "voyage-value"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_miezz_input, {
                                                modelValue: item.Voyage,
                                                "onUpdate:modelValue": ($event: any) => ((item.Voyage) = $event),
                                                number: true,
                                                greaterThanNumber: 0,
                                                pattern: "[0-9]"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1032, ["prop", "rules"]),
                                          _createVNode(_component_el_form_item, {
                                            prop: `Data.FieldValues[${i}].VoyageUnit`,
                                            rules: _ctx.form.Rules.VoyageUnit,
                                            class: "voyage-unit"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_miezz_select, {
                                                modelValue: item.VoyageUnit,
                                                "onUpdate:modelValue": ($event: any) => ((item.VoyageUnit) = $event),
                                                label: item.VoyageUnitLabel,
                                                "onUpdate:label": ($event: any) => ((item.VoyageUnitLabel) = $event),
                                                options: item.Options,
                                                clearable: false
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                                            ]),
                                            _: 2
                                          }, 1032, ["prop", "rules"])
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                    : (item.ColumnFieldCode == 'SailingDate')
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 7,
                                          label: item.Name,
                                          required: true,
                                          class: "sailing-date"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, {
                                              prop: `Data.FieldValues[${i}].SailingTimeType`,
                                              rules: _ctx.form.Rules.SailingTimeType,
                                              class: "sailing-time-type"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_miezz_select, {
                                                  modelValue: item.SailingTimeType,
                                                  "onUpdate:modelValue": ($event: any) => ((item.SailingTimeType) = $event),
                                                  options: item.Options,
                                                  clearable: false
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                              ]),
                                              _: 2
                                            }, 1032, ["prop", "rules"]),
                                            _createElementVNode("div", _hoisted_8, [
                                              (item.SailingTimeType == _ctx.EnumSailingTimeType.Week)
                                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                    key: 0,
                                                    prop: `Data.FieldValues[${i}].SailingWeekArray`,
                                                    rules: _ctx.form.Rules.SailingWeekArray
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_checkbox_group, {
                                                        modelValue: item.SailingWeekArray,
                                                        "onUpdate:modelValue": ($event: any) => ((item.SailingWeekArray) = $event)
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EnumWeekOption, (week) => {
                                                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                                                              key: week.Value,
                                                              label: week.Value,
                                                              class: "sailing-week"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(week.Label), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["label"]))
                                                          }), 128))
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["prop", "rules"]))
                                                : (_openBlock(), _createBlock(_component_el_form_item, {
                                                    key: 1,
                                                    prop: `Data.FieldValues[${i}].SailingDate`,
                                                    rules: _ctx.form.Rules.SailingDate,
                                                    class: "sailing-date-time"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_date_picker, {
                                                        modelValue: item.SailingDate,
                                                        "onUpdate:modelValue": ($event: any) => ((item.SailingDate) = $event),
                                                        type: "date",
                                                        format: "YYYY/MM/DD",
                                                        "value-format": "YYYY/MM/DD",
                                                        class: "form-item-date"
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["prop", "rules"]))
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["label"]))
                                      : (item.ColumnFieldCode == 'Link')
                                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                                            key: 8,
                                            label: item.Name,
                                            class: "link"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, {
                                                prop: `Data.FieldValues[${i}].LinkLabel`,
                                                rules: _ctx.form.Rules.LinkLabel,
                                                class: "link-label"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_miezz_input, {
                                                    modelValue: item.LinkLabel,
                                                    "onUpdate:modelValue": ($event: any) => ((item.LinkLabel) = $event),
                                                    placeholder: "请填写超链接文本"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                ]),
                                                _: 2
                                              }, 1032, ["prop", "rules"]),
                                              _createVNode(_component_el_form_item, {
                                                prop: `Data.FieldValues[${i}].Link`,
                                                rules: _ctx.form.Rules.Link,
                                                class: "link-href"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_miezz_input, {
                                                    modelValue: item.Link,
                                                    "onUpdate:modelValue": ($event: any) => ((item.Link) = $event),
                                                    placeholder: "请填写超链接"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                ]),
                                                _: 2
                                              }, 1032, ["prop", "rules"])
                                            ]),
                                            _: 2
                                          }, 1032, ["label"]))
                                        : (item.ColumnFieldCode == 'Remark')
                                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                                              key: 9,
                                              prop: `Data.FieldValues[${i}].Remark`,
                                              rules: _ctx.form.Rules.Remark,
                                              label: item.Name
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_miezz_input, {
                                                  modelValue: item.Remark,
                                                  "onUpdate:modelValue": ($event: any) => ((item.Remark) = $event),
                                                  type: "textarea",
                                                  trim: false,
                                                  rows: 5
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _: 2
                                            }, 1032, ["prop", "rules", "label"]))
                                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["model"]))
      : _createCommentVNode("", true),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalSetting,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalSetting) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_price_table_column_crud, {
          modelValue: _ctx.modalSetting,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalSetting) = $event)),
          tableId: _ctx.tableId,
          ids: _ctx.columnIds,
          onHandleChoose: _ctx.handleChooseColumn
        }, null, 8, ["modelValue", "tableId", "ids", "onHandleChoose"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}